import { FileDownloadOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useFileStorage } from '@procureai/uix';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { BaseBusinessLogItem, BusinessLogItemProps } from './BaseBusinessLogItem';

export const FileDownloadLogItem = ({ item, virtual }: BusinessLogItemProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'BusinessFeedWidget' });
  const { context } = item;
  const { download } = useFileStorage();

  return (
    <BaseBusinessLogItem
      item={item}
      virtual={virtual}
      secondary={
        <Button
          endIcon={<FileDownloadOutlined />}
          variant="text"
          size="small"
          onClick={() => download({ uploadId: context.fileId, fileName: context.fileName ?? 'download.pdf' })}
        >
          {t('button.download')}
        </Button>
      }
    />
  );
};
